<template>
   <div class='layer-checkbox'>
      <checkbox-field
         :id="'check-'+layer.id"
         :checked="layer.visible"
         :disabled="!layer.enabled"
         :title="layer.enabled ? '' : 'Only visible when zoomed in to municipality level'"
         :label="layer.title"
         color="primary"
         @click="toggleLayer"
      />
      <img :src="layer.legend_path" >
      <div class="layer-info-wrapper">
         <layer-info-icon
            :source="layer.source"
            :description="layer.description"
         />
      </div>
   </div>
</template>

<script>
import CheckboxField from '../CheckboxField';
import LayerInfoIcon from '../LayerInfoIcon';
import { mapActions } from 'vuex';

export default {
   components: {
      CheckboxField,
      LayerInfoIcon,
   },
   props: {
      layer: {
         type: Object,
         required: true,
      }
   },
   methods: {
      ...mapActions('layers', ['setLayerVisibleWithUI']),
      toggleLayer(event)
      {
         this.setLayerVisibleWithUI({layer_id: this.layer.id, visible: event.target.checked});
      },
   }   
}
</script>

<style lang="scss" scoped>
.layer-checkbox {
   margin-bottom: 4px;
   position: relative;

   img {
      display: block;
      margin-left: 20px;
   }

   .layer-info-wrapper {
      position: absolute;
      right: 5px;
      top: 3px;
   }
}
</style>